export const humanFileSize: (size: number) => string = (size) => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return `${(size / Math.pow(1024, i)).toFixed(2)} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
};

export const validateFile: (accept: string, file: File) => boolean = (accept, file) => {
    const rulesList: string[] = accept
        .split(',')
        .map(rule => rule.trim().toLowerCase())
        .filter(rule => rule.length !== 0);

    // (new RegExp(i.accept.replace( '*', '.\*' ))).test( i.files[ 0 ].type )
    return rulesList.filter(rule => rule[0] !== '.')
        .some(rule => (new RegExp(rule.replace('*', '.\*'))).test(file.type))
        || rulesList.filter(rule => rule[0] === '.')
            .some(rule => (new RegExp(`${rule.replace('.', '\.')}\$`)).test(file.name));
};
